import React, { Fragment } from 'react';
import { Row, Col, Space } from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined } from '@ant-design/icons';
import {
  CustomButton,
  FormInput,
  FormSelect,
} from '../../../../components';

interface SearchFiltersProps {
  formik: any;
  onCancel: () => void;
  isLoading?: boolean;
  onOpenFilters: () => void;
}

const SearchFilters: React.FC<SearchFiltersProps> = ({
  formik,
  onCancel,
  isLoading,
  onOpenFilters,
}) => {
  return (
    <Fragment>
      <Row gutter={[16, 16]} className="container-filters">
        <Col xs={24} sm={12} md={12}>
          <FormInput
            label="Buscador"
            name="search"
            placeholder="Buscar por código/placa, descripción, ubicación o centro de costos"
            value={formik.values.search}
            error={formik.errors.search}
            touched={formik.touched.search}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12} md={12}>
          <FormSelect
            label="Estado de la validación"
            name="status_id"
            placeholder="Seleccione estado"
            value={formik.values.status_id}
            options={[
              { name: 'Por verificar', id: '35' },
              { name: 'Verificado', id: '77' },
            ]}
            error={formik.errors.status_id}
            touched={formik.touched.status_id}
            onChange={(value) =>
              formik.setFieldValue('status_id', value)
            }
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>

      <Row className="filters-buttons">
        <Col>
          <Space>
            <CustomButton
              buttonType="secondary"
              label="Limpiar"
              onClick={() => {
                formik.resetForm();
                onCancel();
              }}
              icon={<ReloadOutlined />}
              size="middle"
              disabled={isLoading}
            />

            <CustomButton
              label="Buscar"
              onClick={formik.handleSubmit}
              icon={<SearchOutlined />}
              size="middle"
              disabled={isLoading}
            />
            <CustomButton
              label="Filtros avanzados"
              icon={<PlusOutlined />}
              onClick={onOpenFilters}
              size="middle"
              disabled={isLoading}
              customClass={isLoading ? 'BtnSearchAdvanced_Desactived' : 'BtnSearchAdvanced'}
            />
          </Space>
        </Col>
      </Row>
    </Fragment>
  );
};

export default SearchFilters;
